import { MAINTENANCE_MODE, WEB_URL } from '@petplate/settings';
import { redirect } from 'react-router-dom';

/**
 * Redirects the user to the maintenance page if the maintenance mode is enabled
 */
export const checkMaintenance = async () => {
  const isInMaintenanceMode = MAINTENANCE_MODE === 'true';
  if (isInMaintenanceMode) {
    return redirect(`${WEB_URL}/maintenance`);
  }

  return true;
};
